/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GlobalSetting } from '../models/GlobalSetting';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GlobalSettingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns GlobalSetting OK
     * @throws ApiError
     */
    public saveGlobalSettings({
        requestBody,
    }: {
        requestBody: GlobalSetting,
    }): CancelablePromise<Array<GlobalSetting>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/v1/global-settings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GlobalSetting OK
     * @throws ApiError
     */
    public getGlobalSettings(): CancelablePromise<Array<GlobalSetting>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/v1/global-settings',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
